import type { ReactNode } from "react";
import { cn } from "~/lib/utils";

interface ControlGroupProps {
  children: ReactNode;
  className?: string;
}

/**
 * Container for map controls with consistent styling.
 * Groups one or more control buttons together.
 */
export function ControlGroup({ children, className }: ControlGroupProps) {
  return (
    <div
      className={cn(
        "flex flex-col w-fit bg-card ring-2 ring-border rounded-lg shadow-lg overflow-hidden",
        "[&>*:first-child]:pt-2 [&>*:last-child]:pb-2",
        className,
      )}
    >
      {children}
    </div>
  );
}
